export enum PaymentLoaderType {
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  QR_CODE = 'QR_CODE',
  INTERNAL_PAYMENT_METHOD = 'INTERNAL_PAYMENT_METHOD',
  INSTALMENT_DETAILS = 'INSTALMENT_DETAILS',
  PAYMENT_SUMMARY = 'PAYMENT_SUMMARY',
  APOINT = 'APOINT',
}
